export default "__VITE_ASSET__74dd9524__"